import api from "@/libs/axios";
import type {
    MeResponse,
    LoginPayload,
    LoginResponse,
    RegisterPayload,
    RegisterResponse,
    RefreshResponse,
} from "@/Types/auth/auth";

export const authApi = {

    // GET /auth/me => user object directly
    getMe: (): Promise<MeResponse> =>
        api.get("/api/auth/me").then((r) => r.data),

    // POST /auth/login
    login: (payload: LoginPayload): Promise<LoginResponse> =>
        api.post("/api/auth/login", payload).then((r) => r.data),

    // POST /auth/register
    register: (payload: RegisterPayload): Promise<RegisterResponse> =>
        api.post("/api/auth/register", payload).then((r) => r.data),

    // POST /auth/logout
    logout: (): Promise<void> =>
        api.post("/api/auth/logout").then((r) => r.data),

    // POST /auth/refresh
    refresh: (): Promise<RefreshResponse> =>
        api.post("/api/auth/refresh").then((r) => r.data),

    // POST /auth/revoke-all-sessions
    revokeAllSessions: (): Promise<void> =>
        api.post("/api/auth/revoke-all-sessions").then((r) => r.data),
};